var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVector11(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 430,
    height: 566,
    viewBox: "0 0 430 566",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-383.76 482.053C-355.585 499.911 -325.695 514.906 -294.536 526.812C-242.435 546.807 -187.323 558.443 -131.348 562.991C56.397 578.2 253.933 513.588 380.856 417.087C397.439 404.529 413.226 390.952 428.126 376.436C443.586 361.437 457.739 345.147 470.432 327.743C486.154 305.985 499.207 282.141 507.544 256.635C521.429 214.13 519.713 174.597 506.809 141.979C499.938 124.516 489.58 108.635 476.369 95.3079C463.157 81.9804 447.369 71.4855 429.968 64.4642C406.251 54.7604 379.054 50.9266 349.918 54.5587C334.786 56.2815 319.943 59.9662 305.763 65.52C199.505 108.242 257.607 221.157 156.886 252.993C32.6735 292.299 -24.1504 94.1865 -115.806 40.5124C-165.968 11.1366 -226.213 -12.1861 -318.925 6.97769C-323.673 7.95492 -328.36 9.05799 -332.986 10.2869C-399.334 27.8305 -439.882 59.6209 -470.989 96.9587C-500.935 132.996 -518.942 177.453 -522.521 224.181C-526.022 267.17 -518.008 311.887 -498.525 353.824C-485.013 382.718 -466.84 409.193 -444.733 432.187C-426.499 451.213 -406.025 467.957 -383.76 482.053Z",
    fill: "url(#paint0_linear_1_3346)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_3346",
    x1: -98.8265,
    y1: -180.389,
    x2: -116.759,
    y2: 313.756,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0B67CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0DC3EE",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector11);
export default __webpack_public_path__ + "static/media/Vector11.c45ebc0c47d85a35a8da71f2f71ae243.svg";
export { ForwardRef as ReactComponent };